export const USERNAME_AND_PASSWORD_IDENTITY_TYPE = 'UsernameAndPassword';
export const PHONE_IDENTITY_TYPE = 'Phone';

export const CAPTCHA = 'captcha';
export const MFA = 'mfa';
